<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="data">
    <div class="scrollable-content">
      <div
        *ngIf="selectedTab === myLearningTabStatus.LESSON"
        class="tab-content"
      >
        <div class="lesson-content">
          <div>
            <div
              *ngIf="selectedTopic"
              [innerHTML]="selectedTopic.topic_title"
              class="topic-title"
            ></div>
            <div
              *ngIf="selectedTopic"
              [innerHTML]="selectedTopic.description"
            ></div>
            <div class="subtopics mt-3" *ngIf="selectedTopic.subtopics?.length">
              <div
                *ngFor="let sub of selectedTopic.subtopics"
                class="subtopic mb-2"
              >
                <h5 [innerHTML]="sub.subtopic_title"></h5>
                <p [innerHTML]="sub.description"></p>

                <ul *ngIf="sub.reference_links?.length">
                  <li *ngFor="let link of sub.reference_links">
                    <a [href]="link" target="_blank">{{ link || "N/A" }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Lesson navigation action bar -->
        <div class="lesson-actions">
          <div class="lesson-actions-inner">
            <button
              type="button"
              class="btn-action cancel"
              (click)="goToPreviousLesson()"
              *ngIf="!isFirstLesson()"
            >
              <i class="bi bi-chevron-left"></i>
              <span>Previous</span>
            </button>

            <button
              type="button"
              class="btn-action"
              (click)="goToNextLesson()"
              *ngIf="!isLastLesson()"
            >
              <span>Next Lesson</span>
              <i class="bi bi-chevron-right"></i>
            </button>

            <button
              type="button"
              class="btn-action complete"
              (click)="markLastLessonCompleted()"
              *ngIf="
                isLastLesson() &&
                selectedTopic?.status !== StudentTopicProgressStatus.COMPLETED
              "
            >
              <i class="bi bi-check-circle"></i>
              <span>Mark as Complete</span>
            </button>

            <button
              class="btn-action go-to-courses"
              *ngIf="courseDetails?.progress_percentage === 100"
              (click)="goToProCourses()"
            >
              <i class="bi bi-grid"></i>
              <span>Go to Courses</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
